<div class="modal-card">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-left">
      <div class="header-icon-box">
        <mat-icon>lock_reset</mat-icon>
      </div>
      <div>
        <h3 class="modal-title">Update Password</h3>
        <p class="modal-subtitle">Secure your administrator account</p>
      </div>
    </div>
    <button
      mat-icon-button
      (click)="dialogRef.close()"
      class="close-btn"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body" mat-dialog-content>
    <form [formGroup]="updatePasswordForm">
      <div class="fields-stack">
        <!-- Current Password -->
        <div class="form-field-item">
          <label class="input-label">Current Password</label>
          <div class="password-input-wrap">
            <mat-form-field
              appearance="outline"
              class="w-100"
              subscriptSizing="dynamic"
            >
              <mat-icon matPrefix>key</mat-icon>
              <input
                matInput
                [type]="isShowPassword ? 'text' : 'password'"
                formControlName="oldPassword"
                placeholder="Enter current password"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="showHidePassword()"
                class="eye-toggle-btn"
                aria-label="Toggle password visibility"
              >
                <mat-icon>{{
                  isShowPassword ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <control-messages
            [control]="updatePasswordForm.controls['oldPassword']"
            [inputElmControl]="inputControls.message.required"
          >
          </control-messages>
        </div>

        <!-- New Password -->
        <div class="form-field-item">
          <label class="input-label">New Password</label>
          <div class="password-input-wrap">
            <mat-form-field
              appearance="outline"
              class="w-100"
              subscriptSizing="dynamic"
            >
              <mat-icon matPrefix>lock</mat-icon>
              <input
                matInput
                [type]="isShowNewPassword ? 'text' : 'password'"
                formControlName="newPassword"
                placeholder="Enter new password (min. 8 characters)"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="showHideNewPassword()"
                class="eye-toggle-btn"
                aria-label="Toggle password visibility"
              >
                <mat-icon>{{
                  isShowNewPassword ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <control-messages
            [control]="updatePasswordForm.controls['newPassword']"
            [inputElmControl]="inputControls.message.required"
          >
          </control-messages>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer Actions -->
  <div class="modal-footer" mat-dialog-actions>
    <button mat-stroked-button (click)="dialogRef.close()" class="btn-cancel">
      Cancel
    </button>
    <button mat-flat-button (click)="updatePassword()" class="btn-submit">
      <mat-icon>save</mat-icon>
      Update Password
    </button>
  </div>
</div>
